import 'common/libs/modernizr'
import 'common/otp-input'
import 'devise/controllers'
import $ from 'jquery'

//import 'core-js/features/object';
//import 'core-js/features/string';

import "common/rails";

import 'foundation-sites'

$(function(){
  $(document).foundation();
});
